import script from "./HeaderSearch.vue?vue&type=script&lang=ts&setup=true"
export * from "./HeaderSearch.vue?vue&type=script&lang=ts&setup=true"

import "./HeaderSearch.vue?vue&type=style&index=0&id=c2855f82&scoped=true&lang=css"
import "./HeaderSearch.vue?vue&type=style&index=1&id=c2855f82&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c2855f82"]])

export default __exports__